<template>
  <div>
      <div
      v-if="mostraForm" mostraForm=false
      @click.stop="mostraInserimento=false"
      class="form d-flex align-items-center justify-content-center"
    >
    <transition name="custom" v-on:after-leave="resetForm()" v-on:after-enter="daiFocus()"  enter-active-class="swal2-show"
    leave-active-class="swal2-hide">  
      <div v-if="mostraInserimento" class="container" @click.stop>
        <div class="row intestazione">
          <div class="col-12 text-center my-auto">
            Aggiungi Quantità
            <i class="fas fa-long-arrow-alt-right"></i>
            {{ trItem.value | capitalize}} {{ trItem.modello | capitalize}}
          </div>
        </div>
        <div class="row" style="height:70%;">
          <div class="col-4 h-100">
            <div class="d-flex align-items-center h-100 justify-content-center">
              <img style="width:100%; height:auto;" :src="getImageUrl(trItem)">
            </div>
          </div>
          <div class="col-8 h-100">
            <div class="d-flex flex-row align-items-center h-100">
              <div>
                <label style="float:left;">Quantità da aggiungere</label>
                <input @keydown="onlyNumbers($event)" autocomplete="off" v-model="quantità" id="quanti" placeholder="0">
                <label style="float:left;">Prezzo di acquisto</label>
                 <money @keydown.native="preventMinus($event)" v-model="costo"
                        
                        v-bind="money"
                      ></money>
              </div>
            </div>
          </div>
        </div>
        <div class="row add">
          <div class="col-12 text-center my-auto">
            <div class="info" style="float:left; font-size:10px;">Costo medio attuale:10,80€ | + 0%</div>
            <div :class="{'disabled' : !enableButton }" @click="updateQTY(trItem.id,quantità,costo)" class="tasto" style="float:right;">Aggiungi</div>
          </div>
        </div>
      </div>
       </transition>
    </div>
   
    <div class="overlay d-flex align-items-center justify-content-center">
     
 <div :style="textStyle">{{ _.get(trItem.stock, 'qty', '0')}}</div>
      <div v-if="!squareButton" class="ml-1 aggiungi" @click="aggiungi_qty()"><i class="fas fa-plus-circle"></i></div>
      <div  @click="aggiungi_qty()" class="piu d-flex align-items-center justify-content-center" v-if="squareButton">+</div>
    </div>
  </div>
</template>

<script>
import { ref } from "@/components/puntatori";
import { EventBus } from "../main.js";
import Vue from "vue";
import { Money } from "v-money";
//i pulsanti azioni devono essere un componente a se stante
//header componente ??
//riga componente ? in futuro magari ?

export default {
  name: "crudTableQuantityWidget",
  components: {Money},
  directives: {},
  props: ["trItem", "squareButton", "textStyle"],
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " €",
        precision: 2,
        masked: false

      },
      quantità: '',
      costo: _.get(this.trItem.stock, 'costo', '0'),
      mostraForm: false,
      mostraInserimento: false,
      elementType: "row",
      actualValue: 0,
      newValue: 0,
      inputVisible: false,
      saving: false //SE STO SALVANDO DISATTIVO IL TASTO AGGIUNGI
      // o quadrato
    };
  },
  filters: {
    capitalize: function(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      let value = splitStr.join(" ");
      if (!value) return "";
      value = value.toString();
      return value.replace("Iphone", "iPhone");
    }
  },
  computed: {
    enableButton(){
    if(this.quantità === 0 || this.costo === 0 || this.quantità === ''){return false} else return true  
    }
  },
  methods: {
    preventMinus: function($event){
     if( $event.keyCode===189){
       $event.preventDefault();
     }
    },
     onlyNumbers: function($event){
    	const char = String.fromCharCode(event.keyCode)
    	if (!/[0-9\b]/.test(char)) {
      	event.preventDefault()
      }
    },
    resetForm(){
      this.mostraForm = false
      this.quantità = ''
      this.prezzo = ''
    },
    updateQTY(id, quantità, costo){
      if (!this.saving && this.enableButton){ //PREVIENE CLICK SU AGGIUNGI MENTRE SALVO
        this.saving = true
        let payload = {'itemID' : id,  'qty' : quantità, 'cost' : costo}
        //this.$store.dispatch("magazzinoStates/writeQTYmutation", payload).then( response => {this.mostraInserimento = false, this.saving = false}, error => {});
        this.$store.dispatch("magazzinoStates/addQuantity", payload).then( response => {this.mostraInserimento = false, this.saving = false}, error => {console.log(error)});
      }
    },
    daiFocus(){
      quanti.focus();
    },
    getImageUrl(oggetto) {
      let estensione = oggetto.img_name.substr(oggetto.img_name.length - 4, 4);
      let img_name = oggetto.img_name.substr(0, oggetto.img_name.length - 4);
      if (oggetto.img_name !== null)
        if (oggetto.fonte === "interno" && estensione === ".ext")
          return (
            ref.urlBucketEsterno +
            oggetto.parent +
            "%2F" +
            img_name +
            "?alt=media"
          );
      if (oggetto.fonte === "interno")
        return (
          ref.urlBucket +
          oggetto.parent +
          "%2F" +
          oggetto.img_name +
          "?alt=media"
        );
      if (oggetto.fonte === "esterno")
        return (
          ref.urlBucketEsterno +
          oggetto.parent +
          "%2F" +
          oggetto.img_name +
          "?alt=media"
        );
    },
    aggiungi_qty() {
      this.mostraForm = true;
      Vue.nextTick(() => {
       this.mostraInserimento = true;
       });
     
    }/*, VECCHI OPERAZIONI PER AGGIUNGERE QUANTITA'
    setActualValue(val) {
      this.setActualValue = _.throttle(function(val) {
        var value = parseInt(val);
        if (value >= 0 && value < 999) {
          this.actualValue = value;
          this.updateItem(this.trItem, "quantity", value);
        }
      }, 500);
    },
    updateItem(obj, field, value) {
      var self = this;
      var updates = {};
      updates[obj.id + "/" + field] = value;
      if (obj.fonte === "interno") {
        console.log(updates);
        ref["Interno"].child(obj.parent).update(updates, function(error) {
          if (error) console.log("Errore creazione/aggiornamento aliasValue");
          else {
            console.log("Aggiornato con successo ");
          }
        });
      } else console.log("Fonte esterna o non definita");
    }*/
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>

.piu {
  font-size:2.3vw;
  font-family:'Times New Roman';
  font-weight:bolder;
  margin-left: 8px;
  background-color: #e9e9e9;
  color: #9a9a9a;
  cursor:pointer;
  height: 2.7vw;
  width: 2.7vw;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.disabled{

  background-color:grey !important;
}

.tastoSquared {
  height: 2.7vw;
  width: 2.7vw;
  font-size: 1.5vw;
  background-color: #ececec;
  color: #9a9a9a;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.tasto {
  padding: 0.5vh;
  background-color: #27ae60;
  color: white;
  width: 30%;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  cursor:pointer;
   -webkit-transition: all 500ms;
  -moz-transition: all 500ms;
  -o-transition: all 500ms;
  transition: all 500ms;
}

.info {
  margin-left: 10px;
  padding: 0.5vh;
  font-size: 10px;
  font-weight: 200;
  color: #7f8c8d;
}

.intestazione {
  height: 15%;
  background-color: #595959;
  color: white;
  font-weight: bold;
  font-size: 1.7vh;

  -webkit-border-radius: 9px;
  -webkit-border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius: 9px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-radius: 9px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.add {
  height: 15%;
  background-color: white;
  font-weight: bold;
  font-size: 1.7vh;
  -webkit-border-bottom-right-radius: 9px;
  -webkit-border-bottom-left-radius: 9px;
  -moz-border-radius-bottomright: 9px;
  -moz-border-radius-bottomleft: 9px;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
}

.form {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9999;
  height: 100%;
  width: 100%;
}

.form input {
  height: 5vh;
  width: 100%;
  border: none;
  border-bottom: solid 2px #f3f3f3;
  transition: all 0.2s;

  text-align: right;
  padding-right: 7px;
}
.form input:focus {
  outline: none;
  border-bottom: solid 2px #007bff;
}

.form label {
  font-size: 1.6vh;
  color: #848484;
  margin-top: 1vh;
  margin-left: 1vh;
  margin-bottom: 0.4vh;
}

.form > div {
  height: 37vh;
  width: 32vw;
  background-color: white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.aggiungi {
  color: #e8e8e8;
  -webkit-transition: all 500ms;
  -moz-transition: all 500ms;
  -o-transition: all 500ms;
  transition: all 500ms;
  cursor:pointer;
}

.aggiungi:hover {
  color: green;
}

.diminuisci {
  color: #e8e8e8;
  -webkit-transition: all 500ms;
  -moz-transition: all 500ms;
  -o-transition: all 500ms;
  transition: all 500ms;
}

.diminuisci:hover {
  color: red;
}
.containerButton {
  position: relative;
}

span {
  margin: 20px;
}

.overlay {
  
  font-size: 2.6vh;
  /*background-color: yellow;
  color: white;
  width: 100px;
  height: 100px;
  z-index: 10000000;*/
}

input {
  width: 50px;
}

button {
  top: 0;
  left: 0;
  cursor: pointer;
  width: 35px;
  height: 35px;
  background-color: white;
  border: none;
  background: none;
  background-repeat: no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin-left: 16px;
}

.addButton {
  background-image: url("../assets/img/crudTableQuantityWidget/addButton.svg");
}

.removeButton {
  background-image: url("../assets/img/crudTableQuantityWidget/removeButton.svg");
}

button:disabled {
  opacity: 0.5;
}

button:focus {
  outline: none;
}

button:hover {
  color: #5cb85c !important;
}
</style>
